import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUIGeneralDrawerHeader } from '../../../../../../../atomic/molecules';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material';
import { SCUIButton, SCUILoadingLinear } from '../../../../../../../atomic/atoms';
import Swal from 'sweetalert2';
import { CustomerCommand, OrderCommand } from '../../../../../../../services/command';
import { CustomerAddressEntityFieldsV2 } from '../../../../../../CustomerManagement/components/CustomerAdressInformationPaper/CustomerAddressEntityFieldsV2';
import { AIC_UB, aicCls } from '../addressInformationCard.classes';
import {
    ADDRESS_TYPE_BILLING,
    buildUpdateCustomerAddressInit,
    buildUpdateCustomerAddressPayload,
} from './updateCustomerAddressPayload.helper';

function UpdateBillingAdress({ detail, onClose, setRefresh, addressRules, deliveryMethodId }: any) {
    const { t } = useTranslation();
    const [billingAddress, setBillingAddress] = useState<any>(() => buildUpdateCustomerAddressInit(detail));
    const [loading, setLoading] = useState(false);
    const [value, setValue] = React.useState(
        detail.taxNumber === null || detail.taxNumber.trim().length === 0 ? '1' : '2'
    );

    const handleChange = (event: any) => {
        if (event.target.value === '1') {
            setBillingAddress({
                ...billingAddress,
                taxNumber: null,
                taxOffice: null,
                companyName: null,
            });
        }
        setValue(event.target.value);
    };

    const UpdateCustomerBillingAddress = async () => {
        setLoading(true);
        if (value === '2') {
            if (
                billingAddress.taxNumber === null ||
                billingAddress.taxOffice === null ||
                billingAddress.companyName === null ||
                billingAddress.taxNumber.trim().length === 0 ||
                billingAddress.taxOffice.trim().length === 0 ||
                billingAddress.companyName.trim().length === 0
            ) {
                setLoading(false);
                Swal.fire('', t('addressDetail.missingCompanyInfo'), 'error');
                return;
            }
        }

        if (!billingAddress.phoneNumber || billingAddress.phoneNumber.length < 9) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: t('general.error'),
                text: t('addressDetail.missingPhoneNumber'),
            });
            return;
        }

        try {
            const payload = buildUpdateCustomerAddressPayload(
                billingAddress,
                deliveryMethodId,
                ADDRESS_TYPE_BILLING
            );
            const customerRes: any = await CustomerCommand.UpdateCustomerAddress(payload);
            if (!customerRes) {
                Swal.fire('', ' ', 'error');
                return;
            }
            if (customerRes.statusCode !== 200 && customerRes?.error !== null && customerRes.error?.length > 0) {
                Swal.fire(customerRes?.error, ' ', 'error');
                return;
            }
            if (customerRes?.model?.operationStatus === false) {
                Swal.fire(customerRes?.model?.errorMessageKeyword || '', ' ', 'error');
                return;
            }

            const customerAddressId =
                customerRes?.model?.customerAddressId ?? customerRes?.data?.customerAddressId;
            if (!customerAddressId) {
                Swal.fire('', ' ', 'error');
                return;
            }

            const req = {
                customerId: billingAddress.customerId,
                orderId: billingAddress.orderId,
                orderNumber: billingAddress.orderNumber,
                billingAddressId: customerAddressId,
                shippingAddressId: billingAddress.shippingAddressId,
                confirmationCode: null,
                otpControlAvailable: false,
            };
            const orderRes: any = await OrderCommand.UpdateSaleOrderAddress(req);
            if (orderRes) {
                if (orderRes.error && orderRes.error != null && orderRes.error !== 'null') {
                    Swal.fire('', ' ', 'error');
                } else {
                    Swal.fire(t('general.success'), t('general.updated'), 'success');
                    onClose();
                    setRefresh((prevLoading: any) => !prevLoading);
                }
            }
        } catch (error: any) {
            Swal.fire('', error?.toString?.() || ' ', 'error');
        } finally {
            setLoading(false);
        }
    };
    return (
        <form
            className={AIC_UB.form}
            onSubmit={(e: any) => {
                e.preventDefault();
            }}
        >
            <div className={aicCls('commentFilterContainer', AIC_UB.root)}>
                <Grid className={AIC_UB.grid} container spacing={1}>
                    <SCUIGeneralDrawerHeader
                        header={t('orderDetail.addressEdit')}
                        onClose={onClose}
                        rootClassName={AIC_UB.drawerHeaderRoot}
                        titleClassName={AIC_UB.drawerHeaderTitle}
                        closeIconClassName={AIC_UB.drawerHeaderClose}
                    />
                    <div className={AIC_UB.loadingWrap}>
                        <SCUILoadingLinear display={loading} />
                    </div>
                    <Grid
                        className={AIC_UB.rowFirstName}
                        size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
                        sx={{ marginTop: 0.5 }}
                    >
                        <TextField
                            className={AIC_UB.inputTextFirstName}
                            defaultValue={billingAddress?.firstName}
                            onChange={(e) =>
                                setBillingAddress({
                                    ...billingAddress,
                                    firstName: e.target.value.trim(),
                                })
                            }
                            label={t('general.name')}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        className={AIC_UB.rowLastName}
                        size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
                        sx={{ marginTop: 0.5 }}
                    >
                        <TextField
                            className={AIC_UB.inputTextLastName}
                            defaultValue={billingAddress?.lastName}
                            onChange={(e) =>
                                setBillingAddress({
                                    ...billingAddress,
                                    lastName: e.target.value.trim(),
                                })
                            }
                            label={t('general.surname')}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }} className={AIC_UB.addressEntityWrap}>
                        <CustomerAddressEntityFieldsV2
                            customerAddress={billingAddress}
                            setCustomerAddress={setBillingAddress}
                            addressRules={addressRules}
                            deliveryMethodId={deliveryMethodId}
                        />
                    </Grid>
                    <Grid className={AIC_UB.rowPhone} size={{ xs: 12, md: 12, lg: 12, xl: 12 }} sx={{ marginTop: 0.5 }}>
                        <TextField
                            className={AIC_UB.inputTextPhone}
                            defaultValue={billingAddress?.phoneNumber?.trim?.() ?? ''}
                            label={t('general.phone')}
                            slotProps={{ inputLabel: { shrink: true } }}
                            onChange={(e) =>
                                setBillingAddress({
                                    ...billingAddress,
                                    phoneNumber: e.target.value.trim(),
                                })
                            }
                            fullWidth
                            type="phone"
                        />
                    </Grid>
                    <Grid
                        className={AIC_UB.rowAddress}
                        size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
                        sx={{ marginTop: 0.5 }}
                    >
                        <TextField
                            className={AIC_UB.inputTextAddress}
                            defaultValue={billingAddress?.address}
                            multiline
                            rows={5}
                            label={t('general.address')}
                            slotProps={{ inputLabel: { shrink: true } }}
                            onChange={(e) =>
                                setBillingAddress({
                                    ...billingAddress,
                                    address: e.target.value.trim(),
                                })
                            }
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        className={AIC_UB.invoiceSection}
                        size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
                        sx={{ marginTop: 0.5 }}
                    >
                        <FormControl className={AIC_UB.invoiceFormControl} component="fieldset">
                            <FormLabel component="legend">{t('addressDetail.invoiceType')}</FormLabel>
                            <RadioGroup
                                className={AIC_UB.invoiceRadioGroup}
                                row
                                aria-label="user-type"
                                name="user-type"
                                value={value}
                                onChange={handleChange}
                            >
                                <FormControlLabel
                                    className={AIC_UB.invoiceRadioIndividual}
                                    value="1"
                                    control={<Radio />}
                                    label={t('addressDetail.individual')}
                                />
                                <FormControlLabel
                                    className={AIC_UB.invoiceRadioCorporate}
                                    value="2"
                                    control={<Radio />}
                                    label={t('addressDetail.corporate')}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    {value === '2' && (
                        <>
                            <Grid
                                className={AIC_UB.rowCompany}
                                size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
                                sx={{ marginTop: 0.5 }}
                            >
                                <TextField
                                    className={AIC_UB.inputTextCompany}
                                    defaultValue={billingAddress?.companyName}
                                    label={t('addressDetail.company')}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    onChange={(e) =>
                                        setBillingAddress({
                                            ...billingAddress,
                                            companyName: e.target.value.trim(),
                                        })
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid
                                className={AIC_UB.rowTaxOffice}
                                size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
                                sx={{ marginTop: 0.5 }}
                            >
                                <TextField
                                    className={AIC_UB.inputTextTaxOffice}
                                    defaultValue={billingAddress?.taxOffice}
                                    label={t('addressDetail.taxOffice')}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    onChange={(e) =>
                                        setBillingAddress({
                                            ...billingAddress,
                                            taxOffice: e.target.value.trim(),
                                        })
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid
                                className={AIC_UB.rowTaxNumber}
                                size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
                                sx={{ marginTop: 0.5 }}
                            >
                                <TextField
                                    className={AIC_UB.inputTextTaxNumber}
                                    defaultValue={billingAddress?.taxNumber}
                                    label={t('addressDetail.taxNumber')}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    onChange={(e) =>
                                        setBillingAddress({
                                            ...billingAddress,
                                            taxNumber: e.target.value.trim(),
                                        })
                                    }
                                    fullWidth
                                    type="number"
                                />
                            </Grid>
                        </>
                    )}
                    <Grid
                        className={AIC_UB.rowSubmit}
                        size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
                        sx={{ marginTop: 0.5 }}
                    >
                        <SCUIButton
                            className={AIC_UB.inputButtonUpdate}
                            text={t('general.update')}
                            type="primary"
                            sizeType="fixed"
                            buttonType="submit"
                            size={'m'}
                            fullwidth
                            onClick={UpdateCustomerBillingAddress}
                        />
                    </Grid>
                </Grid>
            </div>
        </form>
    );
}

export default UpdateBillingAdress;
